<script>
import resources from './resources'

export default {
  name: 'gadget-family',

  mixins: [resources]
}
</script>

<template lang="pug">
  section.gadget-paciente-familia.white-bg.wrapper.full-width.gadget(style="margin-bottom: 60px;")
    .gadget-title
      | Familiares
    .actions
      span.icon 
      ul
        li.exclude Remover
        li.half-width Lado a Lado
        li.full-width Tela Inteira
    div
      .col-xs-12.col-md-8
        label.light-blue Integrantes da Família de
        h2.medium-gray {{ user.name }}
      .col-xs-12.col-sm-6.col-md-4
        label.light-blue N° de Integrantes:
        h2.medium-gray {{ dependents.length }}
    .paciente
      .table.col-xs-12
        .row.hidden-xs.hidden-sm
          .col-xs-12.col-sm-3.col-title Nome
          .col-xs-12.col-sm-1.col-title Idade
          .col-xs-12.col-sm-2.col-title Grau
          .col-xs-12.col-sm-4.col-title Convênio
          .col-xs-12.col-sm-2.col-title.text-center Ações
        .order-by.hidden-md.hidden-lg
          | Ordenar por
          span
            select#ordenar-por(name='Ordenar por')
              option(value='Nome') Nome
              option(value='Idade') Idade
              option(value='Grau') Grau
              option(value='Convênio') Convênio
        ul.row
          kinsfolk(v-for="dependent in dependents", :dependent="dependent", :key="dependent.id")
</template>
<style scoped>
  .gadget .table {
    padding: 15px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/app/patient/dashboard/gadget/components/family/family.vue